import { Stack, styled } from '@mui/material';

const StyledOverAllMetrics = styled(Stack)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 0.9rem;
`;

export default StyledOverAllMetrics;
